import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import SizeSetModel from '../../models/SizeSetModel';
import DataService from "../../services/data.service";
import SizeSets_popup_AddSizeSet from './Popups/SizeSets_popup_AddSizeSet';

const SizeSets: React.FC = () => {
    const [data, setData] = useState<SizeSetModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<SizeSetModel[]>('api/v1/sizesets')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/sizesets/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
        { title: 'Name', dataProp: 'name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date' },
        { title: 'End date', dataProp: 'endDate', dataType: 'date' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.EditSize)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true)  }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return <div className='main-content'>
        <Container fluid>
            <Row>
                <Col md={12}>
                    <Card title='Size sets'
                        content={
                            <DataTable
                                name='dtSizeSets'
                                tableData={data}
                                colInfos={colInfos}
                                navigateTitle='Size set'
                                navigateUrl='/plm/itemsetup/sizeset/'
                            />
                        }
                    />
                </Col>
            </Row>
        </Container>
        {showPopup && (<SizeSets_popup_AddSizeSet show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />)}
    </div>
}
export default SizeSets;